import Keycloak from "keycloak-js";
export const keycloak = new Keycloak({
  url: `${process.env.REACT_APP_API_ENDPOINT}/auth`,
  // url: "https://dev.genai-exp.indegene.ai/auth",

  clientId: process.env.REACT_APP_KEYCLOAK_CLIENTID,
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
});
